<mat-radio-button
  [disabled]="disabled()"
  [color]="color()"
  [name]="name()"
  [checked]="viewValue()"
  (change)="updateValue(true)">
  {{ label() }}
  @if (required()) {
    *
  }
</mat-radio-button>
